<template>
  <div class="columns is-multiline">
    <div
      :class="`column is-${12/columns}`"
      v-for="item in items"
      :key="item.id"
    >
      <router-link
        class="button is-fullwidth encyclopediaItem"
        :to="{ path: link(item) }"
      >
        <ItemImage
          v-if="image"
          thumb
          :type="type"
          :id="item.id"
        />
        <span class="is-size-7">{{ item.display_name || item.name || item.label }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import ItemImage from '@/components/Encyclopedia/ItemImage.vue';

export default {
  name: 'items-list',
  components: { ItemImage },
  props: {
    type: String,
    items: Array,
    image: {
      type: Boolean,
      default: true,
    },
    columns: {
      type: Number,
      default: 3,
    },
  },
  methods: {
    link(item) {
      if (
        this.type === 'giants'
        || (this.type === 'locations' && !item.region_id) // regions
      ) {
        return `/encyclopedia/${this.type}/${item.id}`;
      }

      return `/encyclopedia/${this.type}/${item.category_id}/${item.id}`;
    },
  },
};
</script>
